import React from 'react';

import { Box, Button, Divider, Icon, Text } from '@rbilabs/universal-components';

import { CopyButton, DebugToolModal, PluInfo, useDebugToolPosVendor } from 'components/debug-tool';
import { MenuObjectTypes } from 'enums/menu';
import useFoodware from 'hooks/use-foodware';
import { findVendorConfig } from 'utils/vendor-config';

import { getSanityDocumentUrl } from '../utils';

const FoodwareDebugModal: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const { storePosVendor } = useDebugToolPosVendor();
  const { featureFoodware } = useFoodware();

  return (
    <DebugToolModal onOpenEventMessage="Menu Debug Tool: Foodware" onClose={onClose}>
      <Box marginY="$4">
        <Text variant="headerOne">Selected Product:</Text>
        {featureFoodware?.items ? (
          featureFoodware.items.map(foodware => {
            const { name, _id, vendorConfigs } = foodware || {};
            if (name && _id && vendorConfigs) {
              const vendorConfig = findVendorConfig(vendorConfigs, storePosVendor);
              return (
                <React.Fragment key={_id}>
                  <CopyButton
                    label={name?.locale ?? ''}
                    textToCopy={getSanityDocumentUrl(MenuObjectTypes.ITEM, _id)}
                    variant="headerTwo"
                  />
                  {vendorConfig && <PluInfo vendorConfig={vendorConfig} />}
                  <Divider />
                </React.Fragment>
              );
            }
            return (
              <Text variant="headerTwo" key={_id}>
                Error: Encountered null or missing properties when parsing foodware
              </Text>
            );
          })
        ) : (
          <Text variant="headerTwo">No foodware items found.</Text>
        )}
      </Box>
    </DebugToolModal>
  );
};

export const FoodwareDebug = () => {
  const [isDebugMenuModalOpen, setIsDebugMenuModalOpen] = React.useState(false);

  return (
    <>
      <Button
        variant="ghost"
        onPress={() => setIsDebugMenuModalOpen(true)}
        leftIcon={<Icon name="mi:bug-report" />}
      >
        <Text>View Foodware info</Text>
      </Button>

      {isDebugMenuModalOpen && (
        <FoodwareDebugModal onClose={() => setIsDebugMenuModalOpen(false)} />
      )}
    </>
  );
};
